import shuffle from 'lodash/shuffle';
import { Training } from '@/interfaces/class/training';

export default (el: Training) => {
  const enFillersShuffled : {
    [key: string]: {
      count: number;
    };
  } = {};
  const enFillersCorrect = el.enSlices.split('\n');

  shuffle(el.enSlices.toLowerCase().split('\n')).forEach((slice: string) => {
    if (!enFillersShuffled[slice]) {
      enFillersShuffled[slice] = { count: 1 };
    } else {
      enFillersShuffled[slice].count += 1;
    }
  });

  return {
    ...el,
    allAllowedTrainingTypes: ['AudioPuzzlePhrase'],
    allowedTrainingTypes: ['AudioPuzzlePhrase'],
    enFillersCorrect,
    enFillersShuffled,
    partResults: {},
  };
};
